import axiosInstance from "../axiosInstance";
import {toast} from "react-toastify";
import {t} from "i18next";

const shouldHandleError = (error) => {
    let reactorException = error.response?.data
    if (reactorException?.code === 'R6') {
        return false
    }
    return true
}

const baseApiService = {
    get: async (path, params = {}) => {
        try {
            const response = await axiosInstance.get(`${path}`, {params});
            return response.data;
        } catch (error) {
            if (shouldHandleError(error)) {
                toast.error(t(error.response.data ? error.response.data.code : 'general_error'))
            }
            throw error;
        }
    },

    post: async (path, data = {}) => {
        try {
            const response = await axiosInstance.post(`${path}`, data);
            return response.data;
        } catch (error) {
            if (shouldHandleError(error)) {
                toast.error(t(error.response.data ? error.response.data.code : 'general_error'))
            }
            throw error;
        }
    },

    patch: async (path, data = {}) => {
        try {
            const response = await axiosInstance.patch(`${path}`, data);
            return response.data;
        } catch (error) {
            if (shouldHandleError(error)) {
                toast.error(t(error.response.data ? error.response.data.code : 'general_error'));
            }
            throw error;
        }
    },
    delete: async (path) => {
        try {
            const response = await axiosInstance.delete(`${path}`);
            return response.data;
        } catch (error) {
            if (shouldHandleError(error)) {
                toast.error(t(error.response.data ? error.response.data.code : 'general_error'));
            }
            throw error;
        }
    },
};

export default baseApiService;